import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  const values = ['Precios justos para negocios locales', 'Entregas rápidas sin sacrificar calidad', 'Comunicación directa por WhatsApp', 'Soporte real de personas reales'];
  return <section id="nosotros" className="py-32 bg-nova-bg" data-id="element-30">
      <div className="max-w-7xl mx-auto px-6" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[60px] items-center" data-id="element-32">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-33">
            <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-34">
              Somos NovaWeb —{' '}
              <span className="text-nova-accent" data-id="element-35">Tu Aliado Digital</span>
            </h2>
            <div className="w-16 h-[3px] bg-nova-accent mt-4 mb-6" data-id="element-36" />

            <div className="space-y-4 text-lg text-nova-text-muted mb-8" data-id="element-37">
              <p data-id="element-38">Somos una agencia de diseño web con un propósito claro:</p>
              <p className="font-medium text-nova-text" data-id="element-39">
                Ayudar a los negocios locales a tener una presencia digital que
                los haga ver profesionales, genere confianza y atraiga más
                clientes.
              </p>
              <p data-id="element-40">
                No somos una agencia gigante y fría. Somos tu aliado digital.
              </p>
              <p data-id="element-41">
                Entendemos que tu negocio necesita una solución rápida, efectiva
                y sin complicaciones.
              </p>
            </div>

            <div className="mb-8" data-id="element-42">
              <p className="text-nova-text font-semibold mb-4" data-id="element-43">
                Por eso trabajamos con:
              </p>
              <ul className="space-y-3" data-id="element-44">
                {values.map((value, index) => <li key={index} className="flex items-center gap-3" data-id="element-45">
                    <CheckCircle2 className="text-nova-accent shrink-0" size={20} data-id="element-46" />
                    <span className="text-nova-text-muted" data-id="element-47">{value}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex items-center gap-2 text-lg" data-id="element-48">
              <span className="text-nova-text" data-id="element-49"></span>
              <a href="https://wa.me/573508108717" className="text-nova-accent font-bold hover:underline" data-id="element-50"></a>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative flex items-center justify-center" data-id="element-51">
            <motion.img src="https://cdn.magicpatterns.com/uploads/2LPnNy91MsQ8nqXk4ZLbhz/heylloyd-image-1780249317968.png" alt="Diseñador Web Profesional Trabajando" className="w-full rounded-2xl" style={{
            filter: 'drop-shadow(0 0 25px rgba(0, 191, 255, 0.2))',
            borderRadius: '16px'
          }} animate={{
            y: [0, -15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} data-id="element-52" />
          </motion.div>
        </div>
      </div>
    </section>;
}